import { Add } from "@mui/icons-material";
import { Box, Button, Skeleton, Stack, Tab, Tabs, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import TableComp from "src/components/shared/table/TableComp";
import { ACTION_TYPE, USER_ROLE_TYPE } from "src/constant";
import useQueryParams from "src/hooks/useQueryParams";
import ProductDetail from "./ProductDetail/ProductDetail";
import { productSelectList } from "./utils/constant";
import useProductAction from "./utils/useProductAction";
import useProductBody from "./utils/useProductBody";
import useProductTabs from "./utils/useProductTabs";
import useAppGlobal from "src/context/useAppGlobal";
import SetUpVATDialog from "./ProductDetail/SetUpVATDialog";
import ProductFilter from "./components/ProductFilter";
import useProdGroupDetail from "src/hooks/product-groups/useProdGroupDetail";
import useResetParamsOnTabChange from "src/hooks/useResetParamsOnTabChange";
import useAuthGlobal from "src/context/useAuthGlobal";
import { v4 as uuid } from "uuid";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function ProductList() {
  const permissionCheck = useRoleCheck();
  const { userMe } = useAuthGlobal();
  const [option, setOption] = useQueryParams();
  const { handleOpenDialog } = useAppGlobal();
  const productTab = useProductTabs();
  const action = useProductAction();
  const [keyword, setKeyword] = useState();
  const [searchBy, setSearchBy] = useState();
  const [paramsQuery, setParamsQuery] = useState();
  const [searchValue, setSearchValue] = useState();
  const [clear, setClear] = useState(false);

  useResetParamsOnTabChange(option?.tab, setParamsQuery);

  const { bodyList, isLoading, sortData, header, total, setPagi, pagi } = useProductBody({
    keyword,
    searchBy,
    productSelectList,
    paramsQuery,
    productTab,
    searchValue,
  });

  const { data: prodGroupDetail } = useProdGroupDetail(option?.tab === "product" ? undefined : option?.tab);

  const createProduct = () => {
    setOption({ ...option, status: ACTION_TYPE.Create });
  };

  const setUpVAT = () => {
    handleOpenDialog({
      title: "Thiết lập VAT",
      content: <SetUpVATDialog key={uuid()} />,
      size: "md",
    });
  };

  const handleGetValue = (_, value) => {
    setOption({ ...option, tab: value });
  };

  useEffect(() => {
    if (option?.tab) {
      setClear(true);

      const timeout = setTimeout(() => {
        setClear(false);
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [option?.tab]);

  return (
    <Fragment>
      <PageHeader
        name="Quản lý Sản phẩm"
        subName="Sản phẩm"
      />

      {!option?.status && (
        <Box
          display="flex"
          gap={2}
        >
          <Button
            disabled={!permissionCheck([PERMISSIONS.CREATE_PRODUCT])}
            onClick={createProduct}
            variant="contained"
            startIcon={<Add />}
            sx={{ p: "6px 36px", width: "220px", mt: "12px" }}
          >
            Thêm sản phẩm
          </Button>
          <Button
            disabled={!permissionCheck([PERMISSIONS.UPDATE_PRODUCTGROUP])}
            onClick={setUpVAT}
            variant="contained"
            startIcon={<Add />}
            sx={{ p: "6px 36px", width: "220px", mt: "12px" }}
          >
            Thiết lập VAT
          </Button>
        </Box>
      )}

      <Stack
        gap={1.5}
        mb={1.5}
      >
        {!option?.status && (
          <Tabs
            value={option.tab}
            onChange={handleGetValue}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ borderBottom: "1px solid var(--grey)" }}
          >
            {productTab.map((v) => {
              const isDisplayed = [USER_ROLE_TYPE.ADMIN_FACTORY, USER_ROLE_TYPE.SUPER_ADMIN].includes(userMe?.role?.code) && (v?.type === "Retail" || v?.type);
              const isStaff = ![USER_ROLE_TYPE.ADMIN_ACCOUNTANT, USER_ROLE_TYPE.SUPER_ADMIN].includes(userMe?.role?.code) && v?.type === "Retail";
              return (
                (isDisplayed || isStaff) && (
                  <Tab
                    value={v.id}
                    sx={{
                      p: "4px 16px !important",
                      borderBottom: option?.tab === "product" ? (option?.order === v?.tab ? "2px solid" : "") : option?.tab === v?.tabId ? "2px solid" : "",
                    }}
                    key={v.id}
                    label={v.name}
                  />
                )
              );
            })}
          </Tabs>
        )}
        {![ACTION_TYPE.Create, ACTION_TYPE.View, ACTION_TYPE.Update]?.includes(option?.status) && (
          <Box
            display="flex"
            gap="6px"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <SearchFilterComp
              clear={clear}
              width="50%"
              selectList={productSelectList}
              getSearchKeyword={setKeyword}
              getSelectKeyword={setSearchBy}
              getAdditionKeyword={setSearchValue}
            />
            {!prodGroupDetail?.data?.code && (
              <ProductFilter
                setParamsQuery={setParamsQuery}
                paramsQuery={paramsQuery}
              />
            )}
          </Box>
        )}
        {isLoading ? <Skeleton width="100px" /> : <>{!option?.status && <Typography sx={{ fontWeight: "bold" }}>{total ?? 0} Sản phẩm</Typography>}</>}
      </Stack>

      <TableComp
        setPagi={setPagi}
        pagi={pagi}
        total={total}
        dynamicWidth={"800px"}
        bodyList={bodyList}
        headers={header}
        action={action}
        isLoading={isLoading}
        sortData={sortData}
        improvingComp={(!!option?.productId || option?.status === ACTION_TYPE.Create) && <ProductDetail />}
      />
    </Fragment>
  );
}
